<template>
  <section class="app-community">
    <GfrContainer>
      <div class="app-community-module" v-for="(module, index) in ModuleMenuList" :key="index">
        <header class="app-community-module-header">
          <h3 class="text-m-h4 font-medium capitalize text-white max-lg:text-m-h5">{{ module.title }}</h3>
          <IconsDecorLine class="h-1 w-18 text-primary max-lg:w-9 max-lg:h-0.5 rtl:-scale-x-100" />
        </header>
        <div class="app-community-module-list">
          <CommonCard
            v-for="(item, idx) in module.list"
            :key="idx"
            :title="item.title"
            :image="item.image"
            :url="item.url"
            :video="module.type === 'ModuleCommonVideos'"
          />
        </div>
      </div>
    </GfrContainer>
  </section>
</template>

<script setup lang="ts">
import GfrContainer from '~/components/gfr/Container/index.vue'
const pageStore = usePageStore()
const { fetchPageData } = pageStore
const { modules } = storeToRefs(pageStore)
await fetchPageData('/cl-community/')
// const ModuleEventsData = filterModule('ModuleCommonEvents')
// const ModuleVideosData = filterModule('ModuleCommonVideos')
// const ModuleMapsData = filterModule('ModuleCommonMaps')
const ModuleMenuList = computed(() => {
  const data: any[] = []
  modules.value.forEach((module) => {
    const list = module.detail.events || module.detail.videos || module.detail.maps || []
    data.push({
      type: module.component_name,
      ...module.detail,
      list: list.filter((item: any) => item.display === 1).sort((a: any, b: any) => b.weight - a.weight)
    })
  })
  return data
})
</script>

<style scoped lang="scss">
.app-community {
  @apply pt-[62px] pb-13 max-lg:pt-5 max-lg:pb-8;
}
.app-community-module {
  @apply mb-8 last:mb-0 max-lg:mb-4 max-lg:last:mb-0;
}
.app-community-module-header {
  @apply mb-6 max-lg:mb-2;
}
.app-community-module-list {
  @apply grid grid-cols-3 gap-6 max-lg:portrait:grid-cols-1 max-lg:gap-2;
}
</style>
